define('Magento_Theme/js/theme',[
    'jquery',
], function ($) {
    'use strict';

    jQuery.fn.load = function (callback) {
        $(window).on("load", callback)
    };
});

